interface Props {
  title: string;
  description: string;
  image: string;
  url?: string;
  keyword?: string;
}

export default function Meta({
  title, description, image, url = 'https://www.kurly.com', keyword = '마켓컬리, 신선식품',
}: Props) {
  return (
    <>
      <meta name='description' content={description} />
      <meta name='keywords' content={keyword} />
      {/* facebook, kakao 등 SNS */}
      <meta property='og:type' content='website' />
      <meta property='og:site_name' content='마켓컬리 :: 내일의 장보기, 마켓컬리' />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={image} />
      <meta property='og:url' content={url} />
      {/* twitter */}
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={image} />
      <meta name='twitter:url' content={url} />
    </>
  );
}
